import { logger } from '@shared/lib/logger/logger-manager';
import { dbServiceWorker } from '@data/datasource/local/init.db.service-worker';
import { timestamp } from '@shared/lib/date.lib';
import { IServiceWorker } from '@shared/interface/model.interface';

/**
 * Set a line in state table
 * @param {DexieStateTable} stateLine
 * @returns
 */
export const dbAddState = function (stateLine: IServiceWorker): Promise<void> {
  return dbServiceWorker.transaction('rw', dbServiceWorker.state, () => {
    const newStateLine = { ...stateLine };
    newStateLine.timestamp = timestamp(true);

    return dbServiceWorker.state.add(newStateLine).then(() => {
      return dbPurgeState(20);
    });
  });
};

/**
 * Get states
 * @returns
 */
export const dbGetStates = (): Promise<IServiceWorker[]> => {
  return dbServiceWorker.transaction('r', dbServiceWorker.state, () => {
    return dbServiceWorker.state
      .where('timestamp')
      .above(0)
      .reverse()
      .sortBy('timestamp');
  });
};

/**
 * Get last state
 * @returns
 */
export const dbGetLastState = (): Promise<IServiceWorker | undefined> => {
  return dbServiceWorker.transaction('r', dbServiceWorker.state, () => {
    return dbServiceWorker.state
      .where('timestamp')
      .above(0)
      .reverse()
      .sortBy('timestamp')
      .then((rslt) => (rslt.length ? rslt[0] : undefined));
  });
};

/**
 * Purge
 * @param {Number} stateDeep
 */
export const dbPurgeState = (stateDeep = 10) => {
  return dbServiceWorker.transaction('rw', dbServiceWorker.state, async () => {
    if ((await dbServiceWorker.state.count()) > stateDeep) {
      // Récupérer le timestamp du dernier éléments dans la zone logDeep et supprimer ceux qui sont antérieurs
      return dbServiceWorker.state
        .reverse()
        .limit(stateDeep)
        .toArray()
        .then((logs) => {
          const lastOne = logs.pop();

          if (lastOne) {
            dbServiceWorker.state
              .where('id')
              .below(lastOne.id)
              .delete()
              .catch((err) => logger?.error(err));
          }
        })
        .catch((err) => logger?.error(err));
    } else {
      return Promise.resolve();
    }
  });
};
